"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IWorkoutType = void 0;
var IWorkoutType;
(function (IWorkoutType) {
    IWorkoutType["Cardio"] = "cardio";
    IWorkoutType["Cycle"] = "cycle";
    IWorkoutType["Run"] = "run";
    IWorkoutType["Fusion"] = "fusion";
    IWorkoutType["Row"] = "row";
    IWorkoutType["Strength"] = "strength";
})(IWorkoutType || (exports.IWorkoutType = IWorkoutType = {}));
//# sourceMappingURL=workout-type.js.map